import { render, staticRenderFns } from "./AssetAppendix.vue?vue&type=template&id=fdf02828"
import script from "./AssetAppendix.vue?vue&type=script&lang=js"
export * from "./AssetAppendix.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports